import { render } from "./action-comp.vue?vue&type=template&id=193b0988&scoped=true"
import script from "./action-comp.vue?vue&type=script&lang=js"
export * from "./action-comp.vue?vue&type=script&lang=js"

import "./action-comp.vue?vue&type=style&index=0&id=193b0988&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193b0988"]])

export default __exports__